export default __webpack_public_path__ + "static/media/bg-brown.8cab1898.jpg";